import { AssessmentName } from "../Enums/EnumsTypes";
import { scmNameHash } from "../scmNameVaribale";

export const Notify = {
  DEFAULT: "Some error has occurred, check your connection",
  ADD: "Added Successfully",
  SAVED_AS_DRAFT: "Saved as Draft Successfully",
  SUBMITTED_SUCCESSFULLY: "Submitted Successfully",
  DEACTIVATED_SURVEY: "Survey Deactivated",
  ENABLED_SURVEY: "Survey Enabled",
  SCORE_INFO_ENABLED: "Enabled Score & Impact",
  SCORE_INFO_DISABLED: "Disabled Score & Impact",
  SUPPLIER_SETTING: {
    MAX_VALUE_ERROR: "Higher value should be lesser than 10",
    ERROR_MSG: "Please fill all the field",
    TITLE_MSG: "Please fill tittle field",
    IMPACT_MSG: "Please fill impact field",
  },
  SLA_WARN: "Please add SLA",
  POST_SURVEY_FIRST_REMINDER: "Please add first Days",
  FILE_DELETED: "File deleted Successfully",
  FILE_UPLOADED: "Uploaded successfully",
  FILE_LIMIT: (limit: number) =>
    `number of files exceeds the maximum limit of ${limit} files`,
  FILE_SIZE_WARN: "File Size Exceeds 2 MB",
  NUMBER_RANGE_WARN: "Enter number within range",
  SUBMIT_MSG: (scmName: string) =>
    `Are you sure you want to submit the 
    ${
      (scmName && scmNameHash[scmName]) ??
      AssessmentName.ASSESSMENT.toLowerCase()
    }? Once submitted, you will not be able to make any further changes. Please review your answers carefully before proceeding.`,
  MANDATORY_QSTN_WARN: (quesNum: number) =>
    `Please fill question number ${quesNum}`,
  MANDATORY_QSTN_DATE_TO_WARN: (quesNum: number) =>
    `Please fill ranges of question number ${quesNum}`,

  FILE_WARN: "Are you Sure ? Do you want to delete?",
  VERIFIED_OTP: "OTP has been verified successfully",
  RESEND_OTP: "The OTP has been resent successfully.",
};
